import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { AcademicComponent } from 'src/app/view/calendar/academic/academic.component';
import { ActivitiesComponent } from 'src/app/view/calendar/activities/activities.component';
import { CalendarComponent } from 'src/app/view/calendar/calendar.component';
import { ClubComponent } from 'src/app/view/calendar/club/club.component';
import { HolidaysComponent } from 'src/app/view/calendar/holidays/holidays.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    CalendarComponent,
    AcademicComponent,
    ActivitiesComponent,
    ClubComponent,
    HolidaysComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path:'',component:CalendarComponent, children: [
        {path:'academic',component:AcademicComponent},
        {path:'activities',component:ActivitiesComponent},
        {path:'club',component:ClubComponent},
        {path:'holidays',component:HolidaysComponent},
      ]}
    ]),
    SharedModule
  ]
})
export class CalendarModule { }
